
/**
 * This function takes in an object and checks if it is empty or not
 *
 * @param object the object to check
 * @returns {boolean|boolean} true if empty; else false
 */
export function __isEmpty(object) {
    if(object === undefined || object === null) return true;
    for(let key in object) {
        if(object.hasOwnProperty(key))
            return false;
    }
    return true;
}

/**
 * This function takes in an object and checks if it is available (property present and not empty)
 *
 * @param object the object to check
 * @returns {boolean|boolean} the given object has to be not null or undefined and has to have some properties to be available
 */
export function __isAvailable(object) {
    return !__isEmpty(object);
}

/**
 * This function checks if the given identifier exists in the given object or not
 *
 * @param object the object to check
 * @param identifier the property to look for
 * @returns {boolean} true/false
 */
export function __contains(object, identifier) {
    return object.hasOwnProperty(identifier);
}

/**
 * This function checks if a certain key resides in the object or not
 *
 * @param obj the main object
 * @param level the initial level
 * @param rest the rest of the path
 * @returns {boolean} indicates whether given level and ...rest are in the object
 */
export function __isKeyAvailable(obj, level,  ...rest) {
    if (obj === undefined || obj === null) return false;
    if (rest.length === 0 && obj.hasOwnProperty(level)) return true;
    return __isKeyAvailable(obj[level], ...rest)
}

/**
 * This function gets the value in the given nest object property
 *
 * @param obj the object
 * @param args the path to nested property
 * @returns {*} the value at the nested property
 */
export function __getValueIfAvailable(obj, ...args) {
    return args.reduce((obj, level) => obj && obj[level], obj)
}